import {
  TopNav as AtlaskitTopNav,
  TopNavStart,
  TopNavMiddle,
  TopNavEnd,
} from '@atlaskit/navigation-system/layout/top-nav';

import { TopNavErrorBoundary } from 'src/components/error-boundary';

import { useRovoChatContext } from '../nav-system';

import { useTopNavData } from './hooks';
import {
  ToggleSideNavButton,
  AppSwitcher,
  AppLogo,
  Search,
  CreateButton,
  Rovo,
  Notifications,
  Help,
  Settings,
  Profile,
} from './items';

// Our implementation of the TopNav componenent from @atlaskit/navigation-system
export const TopNav = (): JSX.Element => {
  const { isCurrentUserAnonymous } = useTopNavData();
  const { chatState } = useRovoChatContext();

  return (
    <AtlaskitTopNav>
      <TopNavErrorBoundary>
        <TopNavStart sideNavToggleButton={<ToggleSideNavButton />}>
          {!isCurrentUserAnonymous && <AppSwitcher />}
          <AppLogo />
        </TopNavStart>

        <TopNavMiddle>
          <Search />
          {!isCurrentUserAnonymous && <CreateButton />}
        </TopNavMiddle>

        <TopNavEnd>
          {!isCurrentUserAnonymous && chatState.isEnabled && <Rovo />}
          {!isCurrentUserAnonymous && <Notifications />}
          <Help />
          {!isCurrentUserAnonymous && <Settings />}
          {/* the new account menu handles what to show for anonymous users across
        products so we don't have to check it here before rendering  */}
          <Profile />
        </TopNavEnd>
      </TopNavErrorBoundary>
    </AtlaskitTopNav>
  );
};
